<template>
    <div class="whatsapp-message-preview">
        <div class="heading">Preview</div>
        
        <!-- CATALOGUE Template -->
        <div v-if="templateType === 'CATALOGUE'" class="custom-whatsapp-message">
            <div class="content-wrapper">
                <div class="catalogue-card">
                    <div class="catalogue-image-placeholder">
                        <span class="material-icons">image</span>
                    </div>
                    <div class="catalogue-info">
                        <div class="catalogue-title">View {BIZ_NAME}'s Catalog on WhatsApp</div>
                        <div class="catalogue-subtitle">Browse pictures and details of their offerings.</div>
                    </div>
                </div>
                <div class="body">{{ body || "Browse our product catalogue" }}</div>
                <div class="footer" v-if="footer">{{ footer }}</div>
                <div class="timestamp">{{ $moment().format("HH:mm") }}</div>
            </div>
            <div class="buttons">
                <div class="button url">
                    <div class="material-icons">shopping_bag</div>
                    View catalog
                </div>
            </div>
        </div>

        <!-- LIMITED_TIME_OFFER Template -->
        <div v-else-if="templateType === 'LIMITED_TIME_OFFER'" class="custom-whatsapp-message">
            <div class="content-wrapper">
                <template v-if="['IMAGE', 'VIDEO'].includes(headerMediaType)">
                    <template v-if="!headerMediaURL">
                        <img width="100%" :src="getDefaultImage(headerMediaType)" alt="''" />
                    </template>
                    <div v-else-if="headerMediaType === 'VIDEO'">
                        <video width="100%" :src="headerMediaURL" controls />
                    </div>
                    <div v-else-if="headerMediaType === 'IMAGE'">
                        <img width="100%" :src="headerMediaURL" :alt="''" />
                    </div>
                </template>
                <div class="limited-time-offer-box" v-if="limitedTimeOffer && limitedTimeOffer.text">
                    <div class="lto-icon">
                        <span class="material-icons">card_giftcard</span>
                    </div>
                    <div class="lto-content">
                        <div class="lto-title">{{ limitedTimeOffer.text }}</div>
                        <div class="lto-expiry" v-if="limitedTimeOffer.hasExpiration">
                            <template v-if="limitedTimeOffer.expirationDate">
                                <template v-if="typeof limitedTimeOffer.expirationDate === 'string' && limitedTimeOffer.expirationDate.startsWith('[')">
                                    Expires: {{ limitedTimeOffer.expirationDate }}
                                </template>
                                <template v-else>
                                    Expires: {{ $moment(limitedTimeOffer.expirationDate).format('MMM DD, YYYY HH:mm') }}
                                </template>
                            </template>
                            <template v-else>
                                Ends in 2 days
                            </template>
                        </div>
                    </div>
                </div>
                <div class="body">{{ body }}</div>
                <div class="timestamp">{{ $moment().format("HH:mm") }}</div>
            </div>
            <div class="buttons" v-if="buttons && buttons.length">
                <template v-for="(button,index) of buttons.slice(0, buttons.length > 3 ? 2 : 3)">
                    <template v-if="index < 3">
                        <div v-if="button.type === 'URL'" class="button url">
                            <div class="material-icons">open_in_new</div>
                            {{ button.text }}
                        </div>
                        <div v-else-if="button.type === 'PHONE_NUMBER'" class="button url">
                            <div class="material-icons">call</div>
                            {{ button.text }}
                        </div>
                        <div v-else-if="button.type === 'COPY_CODE'" class="button copy-code">
                            <div class="material-icons">content_copy</div>
                            Copy code
                        </div>
                        <div class="button quick-reply" v-else>
                            {{ button.text }}
                        </div>
                    </template>
                </template>
                <div class="button" v-if="buttons.length > 3">
                    <div class="material-icons">list</div>
                    See all options
                </div>
            </div>
        </div>

        <!-- COUPON_CODE Template -->
        <div v-else-if="templateType === 'COUPON_CODE'" class="custom-whatsapp-message">
            <div class="content-wrapper">
                <div class="header-text" v-if="headerText">{{ headerText }}</div>
                <div class="body">{{ body }}</div>
                <div class="timestamp">{{ $moment().format("HH:mm") }}</div>
            </div>
            <div class="buttons" v-if="buttons && buttons.length">
                <template v-for="(button,index) of buttons">
                    <div v-if="button.type === 'QUICK_REPLY'" class="button quick-reply">
                        {{ button.text }}
                    </div>
                    <div v-else-if="button.type === 'COPY_CODE'" class="button copy-code-fixed">
                        <div class="material-icons">content_copy</div>
                        Copy code
                    </div>
                    <div v-else-if="button.type === 'URL'" class="button url">
                        <div class="material-icons">open_in_new</div>
                        {{ button.text }}
                    </div>
                    <div v-else-if="button.type === 'PHONE_NUMBER'" class="button url">
                        <div class="material-icons">call</div>
                        {{ button.text }}
                    </div>
                </template>
            </div>
        </div>

        <!-- CALL_PERMISSION Template -->
        <div v-else-if="templateType === 'CALL_PERMISSION'" class="custom-whatsapp-message">
            <div class="content-wrapper">
                <div class="header-text" v-if="headerText">{{ headerText }}</div>
                <div class="body">{{ body }}</div>
                <div class="footer" v-if="footer">{{ footer }}</div>
                <div class="timestamp">{{ $moment().format("HH:mm") }}</div>
            </div>
            <div class="buttons">
                <div class="button call-permission">
                    Choose preference <div class="material-icons">expand_more</div>
                </div>
            </div>
        </div>

        <!-- Default/Custom Message Template -->
        <div v-else class="custom-whatsapp-message">
            <div class="content-wrapper">
                <template
                    v-if="templateType !== 'CAROUSEL' && ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(headerMediaType)"
                >
                    <template v-if="!headerMediaURL">
                        <img width="100%" :src="getDefaultImage(headerMediaType)" alt="''" />
                    </template>
                    <div v-else-if="headerMediaType === 'DOCUMENT'">
                        <embed :src="headerMediaURL" width="100%" type="application/pdf" />
                    </div>
                    <div v-else-if="headerMediaType === 'VIDEO'">
                        <video width="100%" :src="headerMediaURL" controls />
                    </div>
                    <div v-else-if="headerMediaType === 'IMAGE'">
                        <img width="100%" :src="headerMediaURL" :alt="''" />
                    </div>
                </template>
                <div class="header-text" v-else-if="headerText">{{ headerText }}</div>
                <div class="body">{{ body }}</div>
                <div class="footer" v-if="footer">{{ footer }}</div>

                <div class="timestamp">
                    {{ $moment().format("HH:mm") }}
                </div>
            </div>
            <div class="buttons" v-if="buttons">
                <template v-for="(button,index) of buttons.slice(0, buttons.length > 3 ? 2 : 3)">
                    <template v-if="index < 3">
                        <div v-if="button.type === 'URL'" class="button url">
                            <div class="material-icons">open_in_new</div>
                            {{ button.text }}
                        </div>
                        <div v-else-if="button.type === 'PHONE_NUMBER'" class="button url">
                            <div class="material-icons">call</div>
                            {{ button.text }}
                        </div>
                        <div class="button quick-reply" v-else>
                            {{ button.text }}
                        </div>
                    </template>

                </template>
                <div class="button" v-if="buttons.length > 3">
                    <div class="material-icons">list</div>
                    See all options
                </div>
            </div>
        </div>
        <div class="carousel-whatsapp-message" v-if="templateType === 'CAROUSEL'">
            <div class="carousel-whatsapp-message-item" v-for="card of cards">
                <div class="content-wrapper">
                    <template v-if="!card.mediaUrl">
                        <img width="100%" :src="getDefaultImage(card.headerType)" alt="''" />
                    </template>
                    <template v-else>
                        <div v-if="card.headerType === 'VIDEO'">
                            <video width="100%" :src="card.mediaUrl" controls />
                        </div>
                        <div v-else-if="card.headerType === 'IMAGE'">
                            <img width="100%" :src="card.mediaUrl" :alt="''" />
                        </div>
                        <div v-else-if="card.headerType === 'DOCUMENT'">
                            <img :src="getDefaultImage()" alt="''" />
                        </div>
                    </template>
                    <div class="body">{{ card.sampleText }}</div>
                </div>
                <div class="buttons" v-if="card.buttons">
                    <template v-for="button of card.buttons">
                        <div v-if="button.type === 'URL'" class="button url">
                            <div class="material-icons">open_in_new</div>
                            {{ button.text }}
                        </div>
                        <div class="button quick-reply" v-else>
                            {{ button.text }}
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "WhatsappMessagePreview",
    props: {
        headerType: {
            type: String,
            required: false,
            enum: ["TEXT", "IMAGE"],
        },
        templateType: {
            type: String,
            required: false,
            enum: ["CUSTOM_MESSAGE", "CAROUSEL", "LIMITED_TIME_OFFER", "COUPON_CODE", "CATALOGUE", "CALL_PERMISSION"],
        },
        headerMediaType: {
            type: String,
            required: false,
            enum: ["IMAGE", "VIDEO", "DOCUMENT", "LOCATION"],
        },
        headerMediaURL: {
            type: String,
            required: false,
        },
        headerText: {
            type: String,
            required: false,
        },
        body: {
            type: String,
            required: false,
        },
        footer: {
            type: String,
            required: false,
        },
        buttons: {
            type: Array,
            required: false,
        },
        asset: {
            type: Object,
            default: null,
        },
        cards: {
            type: Array,
            default: () => [],
        },
        limitedTimeOffer: {
            type: Object,
            default: () => ({ text: '', hasExpiration: true }),
        },
        catalogueSubType: {
            type: String,
            default: 'CATALOGUE',
        },
    },
    methods: {
        getDefaultImage(type) {
            const defaultImages = {
                IMAGE: "https://static.supsis.live/static/image-preview.svg",
                VIDEO: "https://static.supsis.live/static/video-preview.svg",
                DOCUMENT: "https://static.supsis.live/static/pdf-preview.svg",
            };
            return defaultImages[type];
        },
    },
});
</script>

<style scoped lang="scss">
.whatsapp-message-preview {
    width: 370px;
    height: 600px;
    min-height: 170px;
    background-image: url(https://static.supsis.live/common/image/whatsapp-bg.webp);
    padding: 16px 12px;
    border-radius: 8px;
    overflow: auto;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 5px;

    .content-wrapper {
        background-color: #fff;
        border-radius: 4px;
        padding: 12px 8px;

        img {
            width: 100%;
        }
    }

    .header-text {
        font-size: 16px;
        font-weight: 500;
        padding: 6px 7px 0px 9px;
        overflow-wrap: break-word;
    }

    .body {
        display: -webkit-box;
        font-size: 14px;
        font-weight: 400;
        color: rgb(63, 63, 63);
        overflow-wrap: break-word;
        word-break: break-word;
        max-width: 100%;
        overflow-y: auto !important;
        max-height: 400px !important;
        padding: 8px 8px 6px !important;
        white-space: pre-line;
    }

    .footer {
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        padding: 0px 7px 8px 9px;
        color: rgb(95, 104, 128);
        overflow-wrap: break-word;
        word-break: break-word;
        display: -webkit-box;
        max-width: 100%;
        max-height: 48px;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: 4px;
    }

    .timestamp {
        text-align: end;
        margin-right: 12px;
        font-size: 12px;
        color: rgb(140, 140, 140);
    }

    .buttons {
        display: flex;
        flex-direction: column;
        gap: 0px;

        .button {
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgb(254, 254, 254);
            margin: 8px 0px;
            padding: 8px 16px;
            text-align: center;
            color: rgb(0, 165, 244);
            cursor: pointer;
            flex-grow: 1;
            border-radius: 6px;
            box-shadow: rgb(175, 183, 191) 0px 1px 3px 0px;
            word-break: break-word;

            &.url {
                gap: 10px;

                .material-icons {
                    font-size: 20px;
                }
            }

            &.copy-code {
                gap: 10px;

                .material-icons {
                    font-size: 18px;
                }
            }

            &.copy-code-fixed {
                background: #e8e8e8;
                color: #333;
                font-weight: 600;
                gap: 10px;
                border: 1px solid #d0d0d0;

                .material-icons {
                    font-size: 18px;
                }
            }

            &.call-permission {
                gap: 10px;
                border: 1px solid rgb(0, 165, 244);

                .material-icons {
                    font-size: 20px;
                }
            }
        }
    }

    .catalogue-card {
        display: flex;
        gap: 12px;
        padding: 12px;
        background: #f5f5f5;
        border-radius: 8px;
        margin-bottom: 12px;
        border: 1px solid #e0e0e0;

        .catalogue-image-placeholder {
            width: 64px;
            height: 64px;
            background: #d9d9d9;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;

            .material-icons {
                font-size: 32px;
                color: #999;
            }
        }

        .catalogue-info {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 4px;
            min-width: 0;

            .catalogue-title {
                font-weight: 600;
                font-size: 14px;
                color: #262626;
                line-height: 1.3;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .catalogue-subtitle {
                font-size: 13px;
                color: #595959;
                line-height: 1.4;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
        }
    }

    .limited-time-offer-box {
        display: flex;
        gap: 12px;
        padding: 14px 16px;
        background: #f5f5f5;
        border-radius: 8px;
        margin-bottom: 12px;
        border: 1px solid #e0e0e0;
        align-items: center;

        .lto-icon {
            width: 48px;
            height: 48px;
            background: linear-gradient(135deg, #95de64 0%, #73d13d 100%);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;

            .material-icons {
                font-size: 24px;
                color: white;
            }
        }

        .lto-content {
            flex: 1;

            .lto-title {
                font-weight: 600;
                font-size: 15px;
                color: #262626;
                margin-bottom: 2px;
            }

            .lto-expiry {
                font-size: 13px;
                color: #595959;
            }
        }
    }

    .carousel-whatsapp-message {
        display: flex;
        gap: 10px;
        width: 100%;
        overflow: auto;

        .carousel-whatsapp-message-item {
            min-width: 260px;
            width: 260px;
            align-self: flex-start;
        }
    }
}
</style>
